<template>
  <div class="container" id="empty-box">
    <div class="row">
      <div class="col-sm-12">
        <span>{{ this.message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Message",
  props: {
    message: {
      type: String,
      default: "Menu is empty, no product is available to order at the moment.",
    },
    type: {
      type: String,
      default: "message",
    },
  },
};
</script>
